var React = require('react');

function TwitterxIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipRule":"evenodd"},[React.createElement("path",{"d":"m27.9237 26.4411-6.1215-8.569h-3.267l7.5845 10.6122.9542 1.3365 6.4928 9.0915h3.267l-7.9585-11.1375z","key":0}),React.createElement("path",{"d":"m27.5 0c-15.1772 0-27.5 12.3228-27.5 27.5 0 15.1773 12.3228 27.5 27.5 27.5 15.1773 0 27.5-12.3227 27.5-27.5 0-15.1772-12.3227-27.5-27.5-27.5zm5.0655 40.403-6.5697-9.3582-8.2253 9.3582h-2.1257l9.4105-10.7002-9.4105-13.398h7.1774l6.2206 8.8605 7.7934-8.8605h2.1258l-8.9732 10.2052 9.7542 13.893z","key":1})]));
}

TwitterxIconInline.defaultProps = {"height":"55","viewBox":"0 0 55 55","width":"55"};

module.exports = TwitterxIconInline;

TwitterxIconInline.default = TwitterxIconInline;
